import React, {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {toast} from 'react-toastify';
import {getUserDetails} from '../common/async/AsyncCalls';
import {USER_ACTION_TYPE} from '../common/state/profile/user';
import Footer from '../components/footer/Footer';
import { useAuth0 } from '@auth0/auth0-react';
// custom
import RouterApp from '../router/RouterApp';
import { retrieveVendor } from '../common/helpers/CommonUtil';

function App() {
    const { user, isAuthenticated, getAccessTokenSilently} = useAuth0();    

    // dispatch
    const profileDispatch : (data : {type: USER_ACTION_TYPE,payload: any}) => void = useDispatch();

    // evt handlers
    const redirectDashboard = (role : boolean) => {
        if (role) window.location.href = `#/admin`;
        else window.location.href = `#/profile`;
    };
    
    // lifecycle
    const checkUserDetails = React.useCallback(async () => {
        if (!isAuthenticated) return;
        console.log('User details is: ', user);        
        const accessToken = await getAccessTokenSilently({
            authorizationParams: {
                audience: "https://api.powerministry.link",
                scope: "openid profile email"
            }
        });
        console.log('Access Token is: ', accessToken);
        const response = await getUserDetails(accessToken);
        if (!response || !response?.data) return;
        const { message } = response.data;                        
        toast(`Welcome ${user?.name?? ``}`);
        // Dispatch user information
        profileDispatch({
            type: USER_ACTION_TYPE.USER_PROFILE_UPDATE,
            payload: {            
                name: user?.name?? '',
                email: user?.email?? '',
                vendor: retrieveVendor(user?.sub?? ''),
                image: user?.picture ?? '',
                role: message? 'admin' : 'new', 
            } 
        });
        // Dispatch access token
        profileDispatch({
            type: USER_ACTION_TYPE.TOKEN_UPDATE,
            payload: accessToken
        });
        redirectDashboard(message);                    
    }, [getAccessTokenSilently, isAuthenticated, profileDispatch, user]);

  useEffect(() => {
      checkUserDetails();
  },[isAuthenticated]);

    return (
        <React.Fragment>
            <RouterApp/>
            <Footer/>
        </React.Fragment>
    );
}

export default App;
